import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-switch-message',
  templateUrl: './switch-message.component.html',
  styleUrls: ['./switch-message.component.scss']
})
export class SwitchMessageComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private _router: Router
  ) { }
  switchTeam(){
    this.activeModal.dismiss();
      this._router.navigateByUrl('/teamsSelection');
  }
  close() {
    this.activeModal.dismiss();
    }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/switch-message/switch-message.component.ts